import type {BranchMergeInProgressEntry} from '@packages/systems/designer/branch';

// BranchActivityStore keeps one merge entry, keyed by branch id for page
// branches and releases alike.
export const isBranchMergingRemotely = (
  mergeEntry: BranchMergeInProgressEntry | null | undefined,
  branchId: string | null | undefined
) =>
  Boolean(
    branchId &&
    mergeEntry?.origin === 'remote' &&
    mergeEntry.status === 'merging' &&
    mergeEntry.branchId === branchId
  );
